export default function(
  url: string,
  twitterText: string,
  twitterVia: string,
  twitterHashtags: string[],
  twitterHref: string = 'https://twitter.com/intent/tweet',
) {
  const params = makeParams({
    text: twitterText,
    via: twitterVia,
    hashtags: twitterHashtags,
    url: window.location.origin + url,
  });
  const tweetURL = twitterHref + (params.length > 0 ? `?${params}` : ``);

  const windowOptions = 'scrollbars=yes,resizable=yes,toolbar=no,location=yes';
  const width = 550;
  const height = 420;
  const winHeight = screen.height;
  const winWidth = screen.width;

  const left = Math.round(winWidth / 2 - width / 2);
  let top = 0;

  if (winHeight > height) {
    top = Math.round(winHeight / 2 - height / 2);
  }

  return window.open(
    tweetURL,
    'intent',
    windowOptions +
      ',width=' +
      width +
      ',height=' +
      height +
      ',left=' +
      left +
      ',top=' +
      top,
  );
}

function makeParams(params: any) {
  const esc = encodeURIComponent;
  return Object.keys(params)
    .filter((k) => params[k])
    .map((k) => esc(k) + '=' + esc(params[k]))
    .join('&');
}
